'use client';

import { getUtag, Utag } from '../tracking';
import { useEffect } from 'react';
import { useIsTrackerReady } from './use-is-tracker-ready';

type UseUtagHook = (closure: (utag: Utag) => void, deps?: any[]) => void;

/**
 * Use utag when it's ready.
 *
 * ```tsx
 * useUtag(utag => {
 *   utag.link(...);
 * }, []);
 * ```
 */
export const useUtag: UseUtagHook = (closure, deps) => {
  let trackerReady = useIsTrackerReady();

  useEffect(
    () => {
      if (!trackerReady) {
        return;
      }

      let utag = getUtag(window);

      if (typeof utag === 'undefined') {
        return;
      }

      closure(utag);
    },
    deps ? [trackerReady, ...deps] : undefined,
  );

  return;
};
